import { versions_0_0_0 } from "./0.0.0";
import { versions_1_0_0 } from "./1.0.0";
import { BlockRestorersList } from "../../objects/blockRestorersList";

export default {
    '0.0.0': versions_0_0_0,
    '1.0.0': versions_1_0_0,
} as BlockRestorersList;